<template>
  <div class="user-info">
    <el-row>
      <el-col :span="8">
        <div class="radius" style="margin-right: 20px">
          <div class="user-title">{{ $t("other.UserInfo.9398620-0") }}</div>
          <div class="vue-padding head-img">
            <avatar-user :user="userInfo"></avatar-user>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="radius">
          <div class="user-title">{{ $t("other.UserInfo.9398620-1") }}</div>
          <div class="vue-padding">
            <el-form ref="userInfo" :model="userInfo" :rules="rules" label-width="80px">
              <el-form-item :label="$t('other.UserInfo.9398620-2')" prop="nickName" :error="error.nickName">
                <el-input v-model="userInfo.nickName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('other.UserInfo.9398620-3')" prop="emailManger" :error="error.emailManger">
                <el-input v-model="userInfo.emailManger"></el-input>
              </el-form-item>
              <el-form-item :label="$t('other.UserInfo.9398620-4')" prop="mobile" :error="error.mobile">
                <el-input v-model="userInfo.mobile"></el-input>
              </el-form-item>
              <el-form-item :label="$t('other.UserInfo.9398620-5')">
                <el-radio-group v-model="userInfo.sex">
                  <el-radio label="0">{{ $t("other.UserInfo.9398620-6") }}</el-radio>
                  <el-radio label="1">{{ $t("other.UserInfo.9398620-7") }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit('userInfo')">{{ $t("other.UserInfo.9398620-8") }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import config from "@/http/config";
  import avatarUser from "@/components/user/avatarUser";

  export default {
    name: "UserInfo",
    components: {
      avatarUser
    },
    data() {
      const mobile = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("other.UserInfo.9398620-9")));
        } else {
          const reg = new RegExp("^((13\\d)|(14[5-9])|(15[0-35-9])|(166)|(17[0-8])|(18\\d)|(19[8-9]))\\d{8}$");
          if (!reg.test(value)) {
            callback(new Error(this.$t("other.UserInfo.9398620-10")));
          }
          callback();
        }
      };
      return {
        userInfo: {
          nickName: "",
          emailManger: "",
          mobile: "",
          sex: ""
        },
        uploadUrl: config.baseUrl + "authority/file/upload",
        headers: { token: this.$cookies.get("token") },
        error: {
          nickName: "",
          userName: "",
          emailManger: "",
          mobile: ""
        },
        rules: {
          nickName: [
            { required: true, message: this.$t("other.UserInfo.9398620-11"), trigger: "blur" },
            {
              min: 3,
              max: 16,
              message: this.$t("other.UserInfo.9398620-12"),
              trigger: "blur"
            }
          ],
          userName: [
            { required: true, message: this.$t("other.UserInfo.9398620-11"), trigger: "blur" },
            {
              min: 3,
              max: 16,
              message: this.$t("other.UserInfo.9398620-12"),
              trigger: "blur"
            }
          ],
          emailManger: [
            { required: true, message: this.$t("other.UserInfo.9398620-13"), trigger: "blur" },
            {
              type: "emailManger",
              message: this.$t("other.UserInfo.9398620-14"),
              trigger: "blur"
            }
          ],
          mobile: [{ validator: mobile, required: true, trigger: "blur" }]
        }
      };
    },
    mounted() {
      this.imageUrl = this.userInfo.avatar;
    },
    methods: {
      onSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.userInfo.avatar = this.imageUrl;
            this.$api.request(this.$url.AuthorityUser.editUser, this.$method.put, this.userInfo).then(res => {
              if (res.code === 0) {
              } else {
                this.$toolUtil.msg(res, this.error);
              }
            });
          } else {
            return false;
          }
        });
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$message.error(this.$t("other.UserInfo.9398620-15"));
        }
        if (!isLt2M) {
          this.$message.error(this.$t("other.UserInfo.9398620-16"));
        }
        return isJPG && isLt2M;
      }
    }
  };
</script>

<style lang="scss">
  .user-info {
    color: #303133;
  }
  .user-info .user-title {
    font-size: 16px;
    padding: 10px 20px 5px;
    border-bottom: 1px solid #e6ebf5;
  }

  .user-info .vue-padding {
    padding: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
